import { render, staticRenderFns } from "./OrdenesProductos.vue?vue&type=template&id=61e72554"
import script from "./OrdenesProductos.vue?vue&type=script&lang=js"
export * from "./OrdenesProductos.vue?vue&type=script&lang=js"
import style0 from "./OrdenesProductos.vue?vue&type=style&index=0&id=61e72554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports